<template>
  <div>
    <v-container fluid>
      <Govem_bar />
      <base-material-card
        icon="mdi-clipboard-check"
        title="แบบรายงานผลการประเมินการปฏิบัติงาน และรายงานข้อมูลการลา/มาสาย/ขาดราชการ"
        class="px-5 py-3"
      >
        <!-- ส่วนหัวข้อและตั้งค่า -->
        <v-row class="mb-4">
          <v-col cols="12">
            <v-alert
              type="info"
              prominent
              outlined
              border="left"
              colored-border
              elevation="2"
              icon="mdi-information"
            >
              <div class="text-subtitle-1 font-weight-medium">
                แบบรายงานผลการประเมินการปฏิบัติงาน และรายงานข้อมูลการลา/มาสาย/ขาดราชการ ของพนักงานราชการ (แบบ ปผ.พนร.)
              </div>
              <div class="text-body-2">
                ปีงบประมาณ พ.ศ. {{ selectedYear }} - {{ collegeData.user_firstname || 'ไม่ระบุสถาบัน' }}
              </div>
              <div class="text-caption mt-1">
                <strong>รอบที่ 1:</strong> 1 ต.ค. {{ selectedYear - 1 }} - 31 มี.ค. {{ selectedYear }} |
                <strong>รอบที่ 2:</strong> 1 เม.ย. {{ selectedYear }} - 30 ก.ย. {{ selectedYear }}
              </div>
              <div class="text-caption mt-1 grey--text">
                <v-icon x-small>mdi-scale-balance</v-icon>
                เกณฑ์คะแนน: ดีเด่น 95-100 | ดีมาก 85-94 | ดี 75-84 | พอใช้ 65-74 | ต้องปรับปรุง &lt;65
                (ตามประกาศ สอศ. พ.ศ. 2569)
              </div>
            </v-alert>
          </v-col>

          <v-col cols="12" md="3">
            <v-select
              v-model="selectedYear"
              :items="years"
              label="ปีงบประมาณ"
              outlined
              dense
              @change="loadAllData"
            ></v-select>
          </v-col>

          <v-col cols="12" md="3">
            <v-select
              v-model="selectedRound"
              :items="roundOptions"
              label="รอบการประเมิน"
              outlined
              dense
              @change="loadAssessmentData"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6" class="text-right">
            <v-btn
              color="primary"
              @click="loadAllData"
              :loading="loading"
              class="mr-2"
            >
              <v-icon left>mdi-refresh</v-icon>
              โหลดข้อมูลใหม่
            </v-btn>

            <v-btn
              color="success"
              @click="generateReport"
              :disabled="!canGenerateReport"
              class="mr-2"
            >
              <v-icon left>mdi-chart-line</v-icon>
              สร้างรายงานสรุป
            </v-btn>

            <v-btn
              color="info"
              @click="exportToExcel"
              :disabled="assessmentData.length === 0 && attendanceData.length === 0"
            >
              <v-icon left>mdi-file-excel</v-icon>
              ส่งออก Excel (แบบ ปผ.พนร.)
            </v-btn>
          </v-col>
        </v-row>

        <!-- สรุปข้อมูลรวม -->
        <v-row class="mb-4" v-if="reportSummary">
          <v-col cols="12">
            <v-card class="pa-4" outlined>
              <v-row>
                <v-col cols="12" md="2">
                  <v-card-text class="text-center">
                    <h3 class="info--text">{{ reportSummary.total_employees || 0 }}</h3>
                    <p>จำนวนพนักงานทั้งหมด</p>
                  </v-card-text>
                </v-col>
                <v-col cols="12" md="2">
                  <v-card-text class="text-center">
                    <h3 class="success--text">{{ reportSummary.submitted_round1 || 0 }}</h3>
                    <p>ประเมินรอบ 1</p>
                  </v-card-text>
                </v-col>
                <v-col cols="12" md="2">
                  <v-card-text class="text-center">
                    <h3 class="info--text">{{ reportSummary.submitted_round2 || 0 }}</h3>
                    <p>ประเมินรอบ 2</p>
                  </v-card-text>
                </v-col>
                <v-col cols="12" md="2">
                  <v-card-text class="text-center">
                    <h3 class="primary--text">{{ formatNumber(reportSummary.avg_score_round1) }}</h3>
                    <p>คะแนนเฉลี่ยรอบ 1</p>
                  </v-card-text>
                </v-col>
                <v-col cols="12" md="2">
                  <v-card-text class="text-center">
                    <h3 class="warning--text">{{ reportSummary.total_sick_leave || 0 }}</h3>
                    <p>วันลาป่วยรวม</p>
                  </v-card-text>
                </v-col>
                <v-col cols="12" md="2">
                  <v-card-text class="text-center">
                    <h3 class="error--text">{{ reportSummary.total_discipline_cases || 0 }}</h3>
                    <p>คดีวินัยรวม</p>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <!-- Tabs -->
        <v-tabs v-model="activeTab" background-color="transparent" color="primary">
          <v-tab key="assessment">ผลการประเมินการปฏิบัติงาน</v-tab>
          <v-tab key="attendance">ข้อมูลการลา/มาสาย/ขาดราชการ</v-tab>
          <v-tab key="discipline">การถูกสั่งลงโทษทางวินัย/คดีอาญา</v-tab>
          <v-tab key="log">
            <v-icon left small>mdi-history</v-icon>
            ประวัติการเปลี่ยนแปลง
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab">
          <!-- ===== Tab 1: การประเมินการปฏิบัติงาน ===== -->
          <v-tab-item key="assessment">
            <v-card flat>
              <v-card-title>
                <span>ผลการประเมินการปฏิบัติงาน ปีงบประมาณ {{ selectedYear }} - {{ getRoundLabel(selectedRound) }}</span>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="openAssessmentDialog()">
                  <v-icon left>mdi-plus</v-icon>
                  เพิ่มการประเมิน
                </v-btn>
              </v-card-title>

              <!-- ตรวจความครบถ้วนการรายงาน 2 รอบ ตามวันที่บรรจุครั้งแรก/การพ้นสภาพ/สัญญาจ้าง (กติกาฝั่งเซิร์ฟเวอร์) -->
              <v-card-text class="pt-0">
                <AssessmentCompleteness
                  :year="selectedYear"
                  :refresh-key="completenessKey"
                  @add="quickAddAssessment"
                />
              </v-card-text>

              <v-data-table
                :headers="assessmentHeaders"
                :items="assessmentData"
                :loading="loading"
                class="elevation-1"
                :items-per-page="15"
              >
                <template v-slot:item.index="{ item }">
                  {{ assessmentData.indexOf(item) + 1 }}
                </template>

                <template v-slot:item.assessment_round="{ item }">
                  <v-chip small :color="item.assessment_round === 1 ? 'info' : 'info'" text-color="white">
                    รอบที่ {{ item.assessment_round }}/{{ String(item.assessment_year).slice(-2) }}
                  </v-chip>
                </template>

                <template v-slot:item.performance_score="{ item }">
                  <span class="font-weight-bold">{{ formatNumber(item.performance_score) }}</span>/80
                </template>

                <template v-slot:item.competency_score="{ item }">
                  <span class="font-weight-bold">{{ formatNumber(item.competency_score) }}</span>/20
                </template>

                <template v-slot:item.total_score="{ item }">
                  <v-chip small :color="getScoreColor(item.total_score)" text-color="white">
                    {{ formatNumber(item.total_score) }}
                  </v-chip>
                </template>

                <template v-slot:item.performance_grade="{ item }">
                  <v-chip small :color="getGradeColor(item.performance_grade)" text-color="white">
                    {{ item.performance_grade || 'ไม่ระบุ' }}
                  </v-chip>
                </template>

                <template v-slot:item.assessment_status="{ item }">
                  <v-chip small :color="getStatusColor(item.assessment_status)" text-color="white">
                    {{ getStatusLabel(item.assessment_status) }}
                  </v-chip>
                </template>

                <template v-slot:item.file_count="{ item }">
                  <v-chip small :color="item.file_count > 0 ? 'success' : 'error'" text-color="white" @click="openFileDialog(item)">
                    <v-icon left x-small>mdi-paperclip</v-icon>
                    {{ item.file_count || 0 }}
                  </v-chip>
                </template>

                <template v-slot:item.actions="{ item }">
                  <!-- ผลประเมินจากสถานศึกษาเดิม (ย้ายมา ผูกตามเลขบัตร) — ดูได้อย่างเดียว -->
                  <v-tooltip v-if="+item.from_other_college" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip x-small color="purple" dark v-bind="attrs" v-on="on">
                        <v-icon x-small left>mdi-swap-horizontal</v-icon>ผลจากสถานศึกษาเดิม
                      </v-chip>
                    </template>
                    <span>ประเมินโดย {{ item.college_name }} ก่อนย้าย — ใช้ผลนี้ได้ ไม่ต้องประเมินซ้ำ (แก้ไขได้เฉพาะสถานศึกษาเดิม)</span>
                  </v-tooltip>
                  <template v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small color="primary" v-bind="attrs" v-on="on" @click="openFileDialog(item)">
                          <v-icon>mdi-file-upload</v-icon>
                        </v-btn>
                      </template>
                      <span>จัดการไฟล์แนบ</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small color="info" v-bind="attrs" v-on="on" @click="openAssessmentDialog(item)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไข</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="item.assessment_status === 'draft'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small color="success" v-bind="attrs" v-on="on" @click="changeStatus(item, 'submitted')">
                          <v-icon>mdi-send</v-icon>
                        </v-btn>
                      </template>
                      <span>ส่งประเมิน</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small color="error" v-bind="attrs" v-on="on" @click="deleteAssessment(item)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>ลบ</span>
                    </v-tooltip>
                  </template>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>

          <!-- ===== Tab 2: การลา/มาสาย/ขาดราชการ ===== -->
          <v-tab-item key="attendance">
            <v-card flat>
              <v-card-title>
                <span>ข้อมูลการลา/มาสาย/ขาดราชการ ปีงบประมาณ {{ selectedYear }}</span>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="openAttendanceDialog()">
                  <v-icon left>mdi-plus</v-icon>
                  เพิ่มข้อมูล
                </v-btn>
              </v-card-title>

              <v-data-table
                :headers="attendanceHeaders"
                :items="attendanceData"
                :loading="loading"
                class="elevation-1"
                :items-per-page="15"
              >
                <template v-slot:item.index="{ item }">
                  {{ attendanceData.indexOf(item) + 1 }}
                </template>

                <template v-slot:item.sick_summary="{ item }">
                  <span v-if="item.sick_leave_times > 0" class="warning--text">
                    {{ item.sick_leave_times }} ครั้ง / {{ item.sick_leave_days }} วัน
                  </span>
                  <span v-else>-</span>
                </template>

                <template v-slot:item.personal_summary="{ item }">
                  <span v-if="item.personal_leave_times > 0" class="info--text">
                    {{ item.personal_leave_times }} ครั้ง / {{ item.personal_leave_days }} วัน
                  </span>
                  <span v-else>-</span>
                </template>

                <template v-slot:item.maternity_summary="{ item }">
                  <span v-if="item.maternity_leave_times > 0" class="primary--text">
                    {{ item.maternity_leave_times }} ครั้ง / {{ item.maternity_leave_days }} วัน
                  </span>
                  <span v-else>-</span>
                </template>

                <template v-slot:item.late_count="{ item }">
                  <span :class="item.late_count > 0 ? 'red--text font-weight-bold' : ''">
                    {{ item.late_count || '-' }}
                  </span>
                </template>

                <template v-slot:item.absent_count="{ item }">
                  <span :class="item.absent_count > 0 ? 'deep-orange--text font-weight-bold' : ''">
                    {{ item.absent_count || '-' }}
                  </span>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small color="info" v-bind="attrs" v-on="on" @click="openAttendanceDialog(item)">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>แก้ไข</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small color="error" v-bind="attrs" v-on="on" @click="deleteAttendance(item)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>ลบ</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>

          <!-- ===== Tab 3: การลงโทษทางวินัย ===== -->
          <v-tab-item key="discipline">
            <v-card flat>
              <v-card-title>
                <span>การถูกสั่งลงโทษทางวินัย/ถูกศาลพิพากษาคดีอาญา ปีงบประมาณ {{ selectedYear }}</span>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="openDisciplineDialog()">
                  <v-icon left>mdi-plus</v-icon>
                  เพิ่มข้อมูล
                </v-btn>
              </v-card-title>

              <v-data-table
                :headers="disciplineHeaders"
                :items="disciplineData"
                :loading="loading"
                class="elevation-1"
                :items-per-page="15"
              >
                <template v-slot:item.index="{ index }">
                  {{ index + 1 }}
                </template>

                <template v-slot:item.discipline_type="{ item }">
                  <v-chip small :color="getDisciplineTypeColor(item.discipline_type)" text-color="white">
                    {{ item.discipline_type }}
                  </v-chip>
                </template>

                <template v-slot:item.court_case="{ item }">
                  <v-chip small :color="item.court_case ? 'error' : 'success'" text-color="white">
                    {{ item.court_case ? 'มีคดีอาญา' : 'ไม่มี' }}
                  </v-chip>
                </template>

                <template v-slot:item.discipline_date="{ item }">
                  {{ formatDate(item.discipline_date) }}
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small color="info" v-bind="attrs" v-on="on" @click="openDisciplineDialog(item)">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>แก้ไข</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small color="error" v-bind="attrs" v-on="on" @click="deleteDiscipline(item)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>ลบ</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>

          <!-- ===== Tab 4: ประวัติ Log ===== -->
          <v-tab-item key="log">
            <v-card flat>
              <v-card-title>
                <span>ประวัติการเปลี่ยนแปลง (Audit Log) ปีงบประมาณ {{ selectedYear }}</span>
                <v-spacer></v-spacer>
                <v-select
                  v-model="logFilter"
                  :items="logFilterOptions"
                  label="ประเภท"
                  outlined
                  dense
                  style="max-width: 200px"
                  class="mr-2"
                  @change="loadLogData"
                ></v-select>
                <v-btn color="primary" small @click="loadLogData">
                  <v-icon left>mdi-refresh</v-icon>
                  โหลดใหม่
                </v-btn>
              </v-card-title>

              <v-data-table
                :headers="logHeaders"
                :items="logData"
                :loading="loadingLog"
                class="elevation-1"
                :items-per-page="20"
              >
                <template v-slot:item.index="{ index }">
                  {{ index + 1 }}
                </template>

                <template v-slot:item.log_action="{ item }">
                  <v-chip small :color="getLogActionColor(item.log_action)" text-color="white">
                    {{ getLogActionLabel(item.log_action) }}
                  </v-chip>
                </template>

                <template v-slot:item.changed_fields="{ item }">
                  <span class="text-caption">{{ item.changed_fields || '-' }}</span>
                </template>

                <template v-slot:item.created_at="{ item }">
                  {{ formatDateTime(item.created_at) }}
                </template>

                <template v-slot:item.details="{ item }">
                  <v-tooltip bottom max-width="400">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon x-small color="grey" v-bind="attrs" v-on="on">
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <div>
                      <div v-if="item.old_data"><strong>ข้อมูลเดิม:</strong> {{ item.old_data }}</div>
                      <div v-if="item.new_data"><strong>ข้อมูลใหม่:</strong> {{ item.new_data }}</div>
                      <div v-if="item.action_note"><strong>หมายเหตุ:</strong> {{ item.action_note }}</div>
                      <div v-if="item.action_ip"><strong>IP:</strong> {{ item.action_ip }}</div>
                    </div>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </base-material-card>

      <!-- ===== Dialog การประเมินการปฏิบัติงาน ===== -->
      <v-dialog v-model="assessmentDialog" max-width="900px" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-4">
            {{ editingAssessment.id ? 'แก้ไข' : 'เพิ่ม' }}การประเมินการปฏิบัติงาน
          </v-card-title>
          <v-card-text class="pt-4">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="editingAssessment.id_card"
                    :items="personnelList"
                    item-text="full_name"
                    item-value="id_card"
                    label="เลือกพนักงานราชการ *"
                    outlined
                    :disabled="!!editingAssessment.id"
                    :rules="[v => !!v || 'กรุณาเลือกพนักงาน']"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="editingAssessment.assessment_round"
                    :items="roundOptionsForForm"
                    label="รอบการประเมิน *"
                    outlined
                    :disabled="!!editingAssessment.id"
                    :rules="[v => !!v || 'กรุณาเลือกรอบการประเมิน']"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-menu
                    v-model="assessmentDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formatDate(editingAssessment.assessment_date)"
                        label="วันที่ประเมิน"
                        prepend-icon="mdi-calendar"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editingAssessment.assessment_date"
                      @input="assessmentDateMenu = false"
                      locale="th"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-alert dense type="info" text class="mb-0">
                    <strong>รอบที่ {{ editingAssessment.assessment_round || '...' }}:</strong>
                    {{ editingAssessment.assessment_round === 1
                      ? '1 ต.ค. ' + (selectedYear - 1) + ' - 31 มี.ค. ' + selectedYear
                      : editingAssessment.assessment_round === 2
                        ? '1 เม.ย. ' + selectedYear + ' - 30 ก.ย. ' + selectedYear
                        : 'กรุณาเลือกรอบ' }}
                    |
                    <strong>เกณฑ์:</strong> ดีเด่น 95-100 | ดีมาก 85-94 | ดี 75-84 | พอใช้ 65-74 | ต้องปรับปรุง &lt;65
                  </v-alert>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model.number="editingAssessment.performance_score"
                    label="ผลสัมฤทธิ์ (เต็ม 80) *"
                    type="number"
                    step="0.01"
                    min="0"
                    max="80"
                    outlined
                    :rules="[v => (v >= 0 && v <= 80) || 'คะแนน 0-80']"
                    @input="calculateTotalScore"
                  >
                    <template v-slot:append>
                      <span class="text-caption grey--text">/80</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model.number="editingAssessment.competency_score"
                    label="สมรรถนะ/พฤติกรรม (เต็ม 20) *"
                    type="number"
                    step="0.01"
                    min="0"
                    max="20"
                    outlined
                    :rules="[v => (v >= 0 && v <= 20) || 'คะแนน 0-20']"
                    @input="calculateTotalScore"
                  >
                    <template v-slot:append>
                      <span class="text-caption grey--text">/20</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    :value="formatNumber(calculatedTotalScore)"
                    label="คะแนนรวม 2 ด้าน"
                    outlined
                    readonly
                    background-color="grey lighten-4"
                  >
                    <template v-slot:append>
                      <v-chip small :color="getScoreColor(calculatedTotalScore)" text-color="white">
                        {{ autoGrade }}
                      </v-chip>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="editingAssessment.performance_grade"
                    :items="gradeOptions"
                    label="สรุประดับผลการประเมิน"
                    outlined
                    hint="ระบบจะเสนอระดับอัตโนมัติตามเกณฑ์ สอศ. สามารถเปลี่ยนได้"
                    persistent-hint
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea
                    v-model="editingAssessment.performance_note"
                    label="หมายเหตุการประเมิน"
                    outlined
                    rows="2"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="assessmentDialog = false">ยกเลิก</v-btn>
            <v-btn color="primary" @click="saveAssessment" :loading="saving">
              <v-icon left>mdi-content-save</v-icon>
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ===== Dialog จัดการไฟล์แนบ ===== -->
      <v-dialog v-model="fileDialog" max-width="800px" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-4">
            <v-icon left>mdi-paperclip</v-icon>
            จัดการไฟล์แนบการประเมิน - {{ selectedAssessmentForFile ? selectedAssessmentForFile.full_name : '' }}
            (รอบที่ {{ selectedAssessmentForFile ? selectedAssessmentForFile.assessment_round : '' }})
          </v-card-title>
          <v-card-text class="pt-4">
            <!-- Upload Section -->
            <v-card outlined class="pa-3 mb-4">
              <div class="text-subtitle-2 mb-2">
                <v-icon small color="primary">mdi-cloud-upload</v-icon>
                อัปโหลดไฟล์ใหม่
              </div>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="uploadFileCategory"
                    :items="fileCategoryOptions"
                    label="ประเภทเอกสาร *"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="uploadFileDescription"
                    label="คำอธิบาย"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-file-input
                    v-model="uploadFile"
                    label="เลือกไฟล์ (PDF, รูป, Word)"
                    accept=".pdf,.jpg,.jpeg,.png,.gif,.doc,.docx"
                    outlined
                    dense
                    show-size
                    prepend-icon="mdi-file-document"
                  ></v-file-input>
                </v-col>
              </v-row>
              <v-btn
                color="primary"
                small
                @click="uploadAssessmentFile"
                :loading="uploading"
                :disabled="!uploadFile || !uploadFileCategory"
              >
                <v-icon left>mdi-upload</v-icon>
                อัปโหลด
              </v-btn>
            </v-card>

            <!-- File List -->
            <v-data-table
              :headers="fileHeaders"
              :items="assessmentFiles"
              :loading="loadingFiles"
              class="elevation-1"
              dense
            >
              <template v-slot:item.index="{ index }">
                {{ index + 1 }}
              </template>

              <template v-slot:item.file_category="{ item }">
                <v-chip x-small :color="getFileCategoryColor(item.file_category)" text-color="white">
                  {{ getFileCategoryLabel(item.file_category) }}
                </v-chip>
              </template>

              <template v-slot:item.file_size="{ item }">
                {{ formatFileSize(item.file_size) }}
              </template>

              <template v-slot:item.created_at="{ item }">
                {{ formatDateTime(item.created_at) }}
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn icon x-small color="info" @click="downloadFile(item)">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <v-btn icon x-small color="error" @click="deleteFile(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="fileDialog = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ===== Dialog การลา/มาสาย/ขาดราชการ ===== -->
      <v-dialog v-model="attendanceDialog" max-width="1000px" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-4">
            {{ editingAttendance.id ? 'แก้ไข' : 'เพิ่ม' }}ข้อมูลการลา/มาสาย/ขาดราชการ
          </v-card-title>
          <v-card-text class="pt-4">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="editingAttendance.id_card"
                    :items="personnelList"
                    item-text="full_name"
                    item-value="id_card"
                    label="เลือกพนักงานราชการ *"
                    outlined
                    :disabled="!!editingAttendance.id"
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <!-- ลาป่วย -->
              <v-divider class="mb-3"></v-divider>
              <div class="text-subtitle-2 mb-2 warning--text">
                <v-icon small color="warning">mdi-hospital</v-icon> การลาป่วย
              </div>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field v-model.number="editingAttendance.sick_leave_times" label="จำนวนครั้ง" type="number" min="0" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model.number="editingAttendance.sick_leave_days" label="จำนวนวัน" type="number" min="0" step="0.5" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model.number="editingAttendance.sick_leave_workdays" label="วันทำการ" type="number" min="0" step="0.5" outlined dense></v-text-field>
                </v-col>
              </v-row>

              <!-- ลาคลอดบุตร -->
              <div class="text-subtitle-2 mb-2 primary--text">
                <v-icon small color="primary">mdi-baby-carriage</v-icon> การลาคลอดบุตร
              </div>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field v-model.number="editingAttendance.maternity_leave_times" label="จำนวนครั้ง" type="number" min="0" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model.number="editingAttendance.maternity_leave_days" label="จำนวนวัน" type="number" min="0" step="0.5" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model.number="editingAttendance.maternity_leave_workdays" label="วันทำการ" type="number" min="0" step="0.5" outlined dense></v-text-field>
                </v-col>
              </v-row>

              <!-- ลากิจส่วนตัว -->
              <div class="text-subtitle-2 mb-2 info--text">
                <v-icon small color="info">mdi-account-clock</v-icon> การลากิจส่วนตัว
              </div>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field v-model.number="editingAttendance.personal_leave_times" label="จำนวนครั้ง" type="number" min="0" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model.number="editingAttendance.personal_leave_days" label="จำนวนวัน" type="number" min="0" step="0.5" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model.number="editingAttendance.personal_leave_workdays" label="วันทำการ" type="number" min="0" step="0.5" outlined dense></v-text-field>
                </v-col>
              </v-row>

              <!-- ลาราชการทหาร -->
              <div class="text-subtitle-2 mb-2 success--text">
                <v-icon small color="success">mdi-shield-account</v-icon> การลาราชการทหาร
              </div>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field v-model.number="editingAttendance.military_leave_times" label="จำนวนครั้ง" type="number" min="0" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model.number="editingAttendance.military_leave_days" label="จำนวนวัน" type="number" min="0" step="0.5" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model.number="editingAttendance.military_leave_workdays" label="วันทำการ" type="number" min="0" step="0.5" outlined dense></v-text-field>
                </v-col>
              </v-row>

              <!-- มาสาย/ขาดราชการ -->
              <v-divider class="mb-3"></v-divider>
              <div class="text-subtitle-2 mb-2 error--text">
                <v-icon small color="error">mdi-clock-alert</v-icon> มาสาย/ขาดราชการ
              </div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model.number="editingAttendance.late_count" label="จำนวนครั้งมาสาย" type="number" min="0" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model.number="editingAttendance.absent_count" label="จำนวนวันขาดราชการ" type="number" min="0" outlined dense></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="attendanceDialog = false">ยกเลิก</v-btn>
            <v-btn color="primary" @click="saveAttendance" :loading="saving">
              <v-icon left>mdi-content-save</v-icon>
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ===== Dialog การลงโทษทางวินัย ===== -->
      <v-dialog v-model="disciplineDialog" max-width="1000px" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-4">
            {{ editingDiscipline.id ? 'แก้ไข' : 'เพิ่ม' }}การลงโทษทางวินัย/คดีอาญา
          </v-card-title>
          <v-card-text class="pt-4">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="editingDiscipline.id_card"
                    :items="personnelList"
                    item-text="full_name"
                    item-value="id_card"
                    label="เลือกพนักงาน *"
                    outlined
                    :disabled="!!editingDiscipline.id"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="editingDiscipline.discipline_type"
                    :items="disciplineTypes"
                    label="ประเภทการลงโทษ *"
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formatDate(editingDiscipline.discipline_date)"
                        label="วันที่ถูกลงโทษ *"
                        prepend-icon="mdi-calendar"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editingDiscipline.discipline_date"
                      @input="dateMenu = false"
                      locale="th"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-switch
                    v-model="editingDiscipline.court_case"
                    :true-value="1"
                    :false-value="0"
                    label="ถูกศาลพิพากษาคดีอาญา"
                    color="error"
                  ></v-switch>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="editingDiscipline.discipline_reason"
                    label="เหตุผล/รายละเอียดการลงโทษ *"
                    outlined
                    rows="3"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" v-if="editingDiscipline.court_case">
                  <v-textarea
                    v-model="editingDiscipline.court_detail"
                    label="รายละเอียดคดีอาญา"
                    outlined
                    rows="3"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="disciplineDialog = false">ยกเลิก</v-btn>
            <v-btn color="primary" @click="saveDiscipline" :loading="saving">
              <v-icon left>mdi-content-save</v-icon>
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Snackbar -->
      <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000" top>
        <v-icon left>{{ snackbar.icon }}</v-icon>
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Govem_bar from "../../../components/iven/govem_bar.vue";
import AssessmentCompleteness from "../../../components/govem/AssessmentCompleteness.vue";
import * as XLSX from "xlsx";

export default {
  name: "AssessmentGovem",
  components: { Govem_bar, AssessmentCompleteness },
  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      saving: false,
      uploading: false,
      loadingFiles: false,
      loadingLog: false,
      selectedYear: new Date().getFullYear() + 543,
      selectedRound: 0,
      activeTab: 0,
      dateMenu: false,
      assessmentDateMenu: false,

      user: {},
      collegeData: {},
      personnelList: [],
      completenessKey: 0, // เพิ่มทุกครั้งที่โหลดผลประเมินใหม่ → AssessmentCompleteness ตรวจซ้ำ

      assessmentData: [],
      attendanceData: [],
      disciplineData: [],
      reportSummary: null,
      logData: [],
      logFilter: '',

      assessmentDialog: false,
      attendanceDialog: false,
      disciplineDialog: false,
      fileDialog: false,

      editingAssessment: this.getDefaultAssessment(),
      editingAttendance: this.getDefaultAttendance(),
      editingDiscipline: this.getDefaultDiscipline(),

      // File upload
      selectedAssessmentForFile: null,
      assessmentFiles: [],
      uploadFile: null,
      uploadFileCategory: 'pf_pnr_1_1',
      uploadFileDescription: '',

      years: [],

      roundOptions: [
        { text: "ทุกรอบ", value: 0 },
        { text: "รอบที่ 1 (1 ต.ค. - 31 มี.ค.)", value: 1 },
        { text: "รอบที่ 2 (1 เม.ย. - 30 ก.ย.)", value: 2 }
      ],

      roundOptionsForForm: [
        { text: "รอบที่ 1 (1 ต.ค. - 31 มี.ค.)", value: 1 },
        { text: "รอบที่ 2 (1 เม.ย. - 30 ก.ย.)", value: 2 }
      ],

      // เกณฑ์ตามประกาศ สอศ. พ.ศ. 2569 (ใช้ "ต้องปรับปรุง" ตามประกาศ)
      gradeOptions: ["ดีเด่น", "ดีมาก", "ดี", "พอใช้", "ต้องปรับปรุง"],

      disciplineTypes: [
        "ตักเตือน", "ภาคทัณฑ์", "ตัดเงินเดือน",
        "ลดเงินเดือน", "ปลดออก", "ไล่ออก", "อื่นๆ"
      ],

      fileCategoryOptions: [
        { text: "ปผ.พนร. 1-1 (ประเมินผลสัมฤทธิ์)", value: "pf_pnr_1_1" },
        { text: "ปผ.พนร. 1-2 (ประเมินพฤติกรรม)", value: "pf_pnr_1_2" },
        { text: "ปผ.พนร. 1-3 (สรุปผลการประเมิน)", value: "pf_pnr_1_3" },
        { text: "ปผ.พนร. 1-4 (รายงานผล/การลา)", value: "pf_pnr_1_4" },
        { text: "เอกสารประกอบ", value: "supporting_doc" },
        { text: "อื่นๆ", value: "other" }
      ],

      logFilterOptions: [
        { text: "ทั้งหมด", value: "" },
        { text: "เพิ่มใหม่", value: "insert" },
        { text: "แก้ไข", value: "update" },
        { text: "ลบ", value: "delete" },
        { text: "เปลี่ยนสถานะ", value: "status_change" },
        { text: "อัปโหลดไฟล์", value: "file_upload" },
        { text: "ลบไฟล์", value: "file_delete" }
      ],

      // Headers ตาราง
      assessmentHeaders: [
        { text: "ลำดับ", value: "index", width: "60px", sortable: false },
        { text: "ชื่อ-สกุล", value: "full_name", width: "170px" },
        { text: "ตำแหน่ง", value: "name_postion", width: "120px" },
        { text: "รอบ", value: "assessment_round", width: "110px", align: "center" },
        { text: "ผลสัมฤทธิ์ (80)", value: "performance_score", width: "110px", align: "center" },
        { text: "สมรรถนะ (20)", value: "competency_score", width: "110px", align: "center" },
        { text: "คะแนนรวม", value: "total_score", width: "100px", align: "center" },
        { text: "สรุประดับผล", value: "performance_grade", width: "120px", align: "center" },
        { text: "สถานะ", value: "assessment_status", width: "100px", align: "center" },
        { text: "ไฟล์", value: "file_count", width: "70px", align: "center" },
        { text: "ดำเนินการ", value: "actions", width: "160px", align: "center", sortable: false }
      ],

      attendanceHeaders: [
        { text: "ลำดับ", value: "index", width: "70px", sortable: false },
        { text: "ชื่อ-สกุล", value: "full_name", width: "180px" },
        { text: "ตำแหน่ง", value: "name_postion", width: "130px" },
        { text: "ลาป่วย", value: "sick_summary", width: "130px", align: "center", sortable: false },
        { text: "ลากิจส่วนตัว", value: "personal_summary", width: "130px", align: "center", sortable: false },
        { text: "ลาคลอดบุตร", value: "maternity_summary", width: "130px", align: "center", sortable: false },
        { text: "มาสาย (ครั้ง)", value: "late_count", width: "100px", align: "center" },
        { text: "ขาดราชการ (วัน)", value: "absent_count", width: "110px", align: "center" },
        { text: "ดำเนินการ", value: "actions", width: "110px", align: "center", sortable: false }
      ],

      disciplineHeaders: [
        { text: "ลำดับ", value: "index", width: "70px", sortable: false },
        { text: "ชื่อ-สกุล", value: "full_name", width: "180px" },
        { text: "ประเภทการลงโทษ", value: "discipline_type", width: "140px" },
        { text: "วันที่ถูกลงโทษ", value: "discipline_date", width: "120px" },
        { text: "คดีอาญา", value: "court_case", width: "120px", align: "center" },
        { text: "เหตุผล", value: "discipline_reason", width: "200px" },
        { text: "ดำเนินการ", value: "actions", width: "110px", align: "center", sortable: false }
      ],

      fileHeaders: [   
        { text: "ประเภท", value: "file_category", width: "160px" },
        { text: "ชื่อไฟล์", value: "file_name", width: "200px" },
        { text: "ขนาด", value: "file_size", width: "80px" },
        { text: "ผู้อัปโหลด", value: "uploaded_by_name", width: "120px" },
        { text: "วันที่", value: "created_at", width: "140px" },
        { text: "", value: "actions", width: "80px", sortable: false }
      ],

      logHeaders: [      
        { text: "ประเภท", value: "log_action", width: "120px" },
        { text: "เลขบัตร", value: "id_card", width: "130px" },
        { text: "รอบ", value: "assessment_round", width: "60px", align: "center" },
        { text: "ฟิลด์ที่เปลี่ยน", value: "changed_fields", width: "180px" },
        { text: "ผู้ดำเนินการ", value: "action_by_name", width: "120px" },
        { text: "หมายเหตุ", value: "action_note", width: "200px" },
        { text: "วันเวลา", value: "created_at", width: "150px" },
        { text: "", value: "details", width: "50px", sortable: false }
      ],

      snackbar: { show: false, color: "success", icon: "mdi-check", text: "" }
    };
  },

  computed: {
    canGenerateReport() {
      return (
        this.assessmentData.length > 0 ||
        this.attendanceData.length > 0 ||
        this.disciplineData.length > 0
      );
    },

    calculatedTotalScore() {
      return (
        (parseFloat(this.editingAssessment.performance_score) || 0) +
        (parseFloat(this.editingAssessment.competency_score) || 0)
      );
    },

    autoGrade() {
      return this.getGradeFromScore(this.calculatedTotalScore);
    }
  },

  async mounted() {
    await this.initializeComponent();
  },

  methods: {
    getDefaultAssessment() {
      return {
        id: null,
        id_card: "",
        assessment_round: 1,
        performance_score: 0,
        competency_score: 0,
        performance_grade: "",
        performance_note: "",
        assessment_date: new Date().toISOString().substr(0, 10)
      };
    },

    getDefaultAttendance() {
      return {
        id: null,
        id_card: "",
        sick_leave_times: 0, sick_leave_days: 0, sick_leave_workdays: 0,
        maternity_leave_times: 0, maternity_leave_days: 0, maternity_leave_workdays: 0,
        personal_leave_times: 0, personal_leave_days: 0, personal_leave_workdays: 0,
        military_leave_times: 0, military_leave_days: 0, military_leave_workdays: 0,
        late_count: 0,
        absent_count: 0
      };
    },

    getDefaultDiscipline() {
      return {
        id: null,
        id_card: "",
        discipline_type: "",
        discipline_reason: "",
        discipline_date: new Date().toISOString().substr(0, 10),
        court_case: 0,
        court_detail: ""
      };
    },

    async initializeComponent() {
      this.loading = true;
      try {
        let userSession = JSON.parse(localStorage.getItem("user")) || {};
        let resultUser = await this.$http.post("user.php", {
          ApiKey: this.ApiKey,
          user_ID: userSession.user_ID
        });
        this.user = resultUser.data;
        this.collegeData = resultUser.data;
        this.generateYears();
        await this.loadPersonnelList();
        await this.loadAllData();
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาดในการโหลดข้อมูล", "error", "mdi-alert");
      } finally {
        this.loading = false;
      }
    },

    generateYears() {
      const currentYear = new Date().getFullYear() + 543;
      this.years = [];
      for (let i = 0; i < 5; i++) {
        this.years.push(currentYear - i);
      }
    },

    async loadPersonnelList() {
      try {
        let result = await this.$http.post("government_employee_news.php", {
          ApiKey: this.ApiKey,
          college_code: this.user.user_code,
        });
        let data = result.data;
        data = data.data.filter(person => person.id_card !== '0');
        this.personnelList = data.map(person => ({
          ...person,
          full_name: `${person.frist_name} ${person.last_name}`
        }));
      } catch (error) {
        this.showSnackbar("ไม่สามารถโหลดรายชื่อพนักงานได้", "error", "mdi-alert");
      }
    },

    async loadAllData() {
      this.loading = true;
      try {
        await Promise.all([
          this.loadAssessmentData(),
          this.loadAttendanceData(),
          this.loadDisciplineData(),
          this.loadReportSummary()
        ]);
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาดในการโหลดข้อมูล", "error", "mdi-alert");
      } finally {
        this.loading = false;
      }
    },

    async loadAssessmentData() {
      try {
        let payload = {
          ApiKey: this.ApiKey,
          action: "get",
          college_code: this.user.user_code,
          assessment_year: this.selectedYear
        };
        if (this.selectedRound > 0) {
          payload.assessment_round = this.selectedRound;
        }
        let result = await this.$http.post("gov_em_assessment.php", payload);
        this.assessmentData = result.data || [];
      } catch (error) {
        this.assessmentData = [];
      } finally {
        this.completenessKey++;
      }
    },

    async loadAttendanceData() {
      try {
        let result = await this.$http.post("gov_em_attendance.php", {
          ApiKey: this.ApiKey,
          action: "get",
          college_code: this.user.user_code,
          attendance_year: this.selectedYear
        });
        this.attendanceData = result.data || [];
      } catch (error) {
        this.attendanceData = [];
      }
    },

    async loadDisciplineData() {
      try {
        let result = await this.$http.post("gov_em_discipline.php", {
          ApiKey: this.ApiKey,
          action: "get",
          college_code: this.user.user_code,
          discipline_year: this.selectedYear
        });
        this.disciplineData = result.data || [];
      } catch (error) {
        this.disciplineData = [];
      }
    },

    async loadReportSummary() {
      try {
        let result = await this.$http.post("gov_em_assessment_report.php", {
          ApiKey: this.ApiKey,
          action: "get_report",
          college_code: this.user.user_code,
          report_year: this.selectedYear
        });
        this.reportSummary = result.data && Object.keys(result.data).length > 0 ? result.data : null;
      } catch (error) {
        this.reportSummary = null;
      }
    },

    async loadLogData() {
      this.loadingLog = true;
      try {
        let payload = {
          ApiKey: this.ApiKey,
          action: "get_log",
          college_code: this.user.user_code,
          assessment_year: this.selectedYear,
          limit: 100
        };
        if (this.logFilter) {
          payload.log_action = this.logFilter;
        }
        let result = await this.$http.post("gov_em_assessment.php", payload);
        this.logData = result.data || [];
      } catch (error) {
        this.logData = [];
      } finally {
        this.loadingLog = false;
      }
    },

    getRoundLabel(round) {
      if (round === 1) return "รอบที่ 1 (1 ต.ค. - 31 มี.ค.)";
      if (round === 2) return "รอบที่ 2 (1 เม.ย. - 30 ก.ย.)";
      return "ทุกรอบ";
    },

    calculateTotalScore() {
      this.editingAssessment.performance_grade = this.autoGrade;
    },

    // *** ช่วงคะแนนตามประกาศ สอศ. พ.ศ. 2569 ***
    getGradeFromScore(score) {
      if (score >= 95) return "ดีเด่น";
      if (score >= 85) return "ดีมาก";
      if (score >= 75) return "ดี";
      if (score >= 65) return "พอใช้";
      return "ต้องปรับปรุง";
    },

    // === การประเมิน ===
    // เปิดฟอร์มเพิ่มการประเมิน พร้อมเลือกคนและรอบไว้ล่วงหน้า — ใช้จากรายชื่อ "ยังไม่รายงานผล"
    quickAddAssessment(person, round) {
      this.editingAssessment = {
        ...this.getDefaultAssessment(),
        id_card: person.id_card,
        assessment_round: round
      };
      this.assessmentDialog = true;
    },

    openAssessmentDialog(item = null) {
      if (item) {
        this.editingAssessment = { ...item };
      } else {
        this.editingAssessment = this.getDefaultAssessment();
      }
      this.assessmentDialog = true;
    },

    async saveAssessment() {
      if (!this.editingAssessment.id_card || !this.editingAssessment.assessment_round) {
        this.showSnackbar("กรุณากรอกข้อมูลให้ครบถ้วน", "warning", "mdi-alert");
        return;
      }
      if (this.editingAssessment.performance_score > 80) {
        this.showSnackbar("คะแนนผลสัมฤทธิ์ไม่เกิน 80", "warning", "mdi-alert");
        return;
      }
      if (this.editingAssessment.competency_score > 20) {
        this.showSnackbar("คะแนนสมรรถนะไม่เกิน 20", "warning", "mdi-alert");
        return;
      }

      this.saving = true;
      try {
        const action = this.editingAssessment.id ? "update" : "insert";
        const payload = {
          ApiKey: this.ApiKey,
          action: action,
          ...this.editingAssessment,
          assessment_year: this.selectedYear,
          college_code: this.user.user_code,
          action_by: this.user.id_card || this.user.user_ID,
          action_by_name: this.user.user_firstname || ''
        };

        let result = await this.$http.post("gov_em_assessment.php", payload);
        if (result.data.status) {
          this.showSnackbar("บันทึกการประเมินเรียบร้อย", "success", "mdi-check");
          this.assessmentDialog = false;
          await this.loadAssessmentData();
        } else {
          this.showSnackbar(result.data.message || "เกิดข้อผิดพลาดในการบันทึก", "error", "mdi-alert");
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาดในการบันทึก", "error", "mdi-alert");
      } finally {
        this.saving = false;
      }
    },

    async deleteAssessment(item) {
      if (confirm(`ต้องการลบการประเมินของ ${item.full_name} รอบที่ ${item.assessment_round} หรือไม่?\n(ไฟล์แนบทั้งหมดจะถูกลบด้วย)`)) {
        try {
          let result = await this.$http.post("gov_em_assessment.php", {
            ApiKey: this.ApiKey,
            action: "delete",
            id: item.id,
            action_by: this.user.id_card || this.user.user_ID,
            action_by_name: this.user.user_firstname || ''
          });
          if (result.data.status) {
            this.showSnackbar("ลบการประเมินเรียบร้อย", "success", "mdi-check");
            await this.loadAssessmentData();
          }
        } catch (error) {
          this.showSnackbar("เกิดข้อผิดพลาดในการลบ", "error", "mdi-alert");
        }
      }
    },

    // === สถานะ ===
    async changeStatus(item, newStatus) {
      let confirmMsg = '';
      if (newStatus === 'submitted') {
        confirmMsg = `ต้องการส่งประเมินของ ${item.full_name} รอบที่ ${item.assessment_round} หรือไม่?\n(ต้องมีไฟล์แนบอย่างน้อย 1 ไฟล์)`;
      } else if (newStatus === 'approved') {
        confirmMsg = `ต้องการอนุมัติการประเมินของ ${item.full_name} หรือไม่?`;
      }

      if (!confirm(confirmMsg)) return;

      try {
        let result = await this.$http.post("gov_em_assessment.php", {
          ApiKey: this.ApiKey,
          action: "change_status",
          id: item.id,
          assessment_status: newStatus,
          action_by: this.user.id_card || this.user.user_ID,
          action_by_name: this.user.user_firstname || '',
          approver_id_card: newStatus === 'approved' ? (this.user.id_card || '') : undefined,
          approver_name: newStatus === 'approved' ? (this.user.user_firstname || '') : undefined
        });
        if (result.data.status) {
          this.showSnackbar("เปลี่ยนสถานะเรียบร้อย", "success", "mdi-check");
          await this.loadAssessmentData();
        } else {
          this.showSnackbar(result.data.message || "เกิดข้อผิดพลาด", "error", "mdi-alert");
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error", "mdi-alert");
      }
    },

    // === ไฟล์แนบ ===
    async openFileDialog(item) {
      this.selectedAssessmentForFile = item;
      this.fileDialog = true;
      this.uploadFile = null;
      this.uploadFileCategory = 'pf_pnr_1_1';
      this.uploadFileDescription = '';
      await this.loadAssessmentFiles(item.id);
    },

    async loadAssessmentFiles(assessmentId) {
      this.loadingFiles = true;
      try {
        let result = await this.$http.post("gov_em_assessment.php", {
          ApiKey: this.ApiKey,
          action: "get_files",
          assessment_id: assessmentId
        });
        this.assessmentFiles = result.data || [];
      } catch (error) {
        this.assessmentFiles = [];
      } finally {
        this.loadingFiles = false;
      }
    },

    async uploadAssessmentFile() {
      if (!this.uploadFile || !this.selectedAssessmentForFile) return;

      this.uploading = true;
      try {
        let formData = new FormData();
        formData.append('ApiKey', this.ApiKey);
        formData.append('action', 'upload_file');
        formData.append('assessment_id', this.selectedAssessmentForFile.id);
        formData.append('file_category', this.uploadFileCategory);
        formData.append('file_description', this.uploadFileDescription);
        formData.append('action_by', this.user.id_card || this.user.user_ID);
        formData.append('action_by_name', this.user.user_firstname || '');
        formData.append('assessment_file', this.uploadFile);

        let result = await this.$http.post("gov_em_assessment.php", formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        if (result.data.status) {
          this.showSnackbar("อัปโหลดไฟล์เรียบร้อย", "success", "mdi-check");
          this.uploadFile = null;
          this.uploadFileDescription = '';
          await this.loadAssessmentFiles(this.selectedAssessmentForFile.id);
          await this.loadAssessmentData(); // refresh file_count
        } else {
          this.showSnackbar(result.data.message || "อัปโหลดล้มเหลว", "error", "mdi-alert");
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาดในการอัปโหลด", "error", "mdi-alert");
      } finally {
        this.uploading = false;
      }
    },

    async deleteFile(file) {
      if (!confirm(`ต้องการลบไฟล์ "${file.file_name}" หรือไม่?`)) return;

      try {
        let result = await this.$http.post("gov_em_assessment.php", {
          ApiKey: this.ApiKey,
          action: "delete_file",
          file_id: file.id,
          action_by: this.user.id_card || this.user.user_ID,
          action_by_name: this.user.user_firstname || ''
        });
        if (result.data.status) {
          this.showSnackbar("ลบไฟล์เรียบร้อย", "success", "mdi-check");
          await this.loadAssessmentFiles(this.selectedAssessmentForFile.id);
          await this.loadAssessmentData();
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error", "mdi-alert");
      }
    },

    downloadFile(file) {
      window.open('/HRvec_api/' + file.file_path, '_blank');
    },

    // === การลา ===
    openAttendanceDialog(item = null) {
      if (item) {
        this.editingAttendance = { ...item };
      } else {
        this.editingAttendance = this.getDefaultAttendance();
      }
      this.attendanceDialog = true;
    },

    async saveAttendance() {
      if (!this.editingAttendance.id_card) {
        this.showSnackbar("กรุณาเลือกพนักงาน", "warning", "mdi-alert");
        return;
      }
      this.saving = true;
      try {
        const action = this.editingAttendance.id ? "update" : "insert";
        const payload = {
          ApiKey: this.ApiKey,
          action: action,
          ...this.editingAttendance,
          attendance_year: this.selectedYear,
          college_code: this.user.user_code
        };
        let result = await this.$http.post("gov_em_attendance.php", payload);
        if (result.data.status) {
          this.showSnackbar("บันทึกข้อมูลการลาเรียบร้อย", "success", "mdi-check");
          this.attendanceDialog = false;
          await this.loadAttendanceData();
        } else {
          this.showSnackbar(result.data.message || "เกิดข้อผิดพลาด", "error", "mdi-alert");
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาดในการบันทึก", "error", "mdi-alert");
      } finally {
        this.saving = false;
      }
    },

    async deleteAttendance(item) {
      if (confirm(`ต้องการลบข้อมูลการลาของ ${item.full_name} หรือไม่?`)) {
        try {
          let result = await this.$http.post("gov_em_attendance.php", {
            ApiKey: this.ApiKey,
            action: "delete",
            id: item.id
          });
          if (result.data.status) {
            this.showSnackbar("ลบข้อมูลเรียบร้อย", "success", "mdi-check");
            await this.loadAttendanceData();
          }
        } catch (error) {
          this.showSnackbar("เกิดข้อผิดพลาดในการลบ", "error", "mdi-alert");
        }
      }
    },

    // === วินัย ===
    openDisciplineDialog(item = null) {
      if (item) {
        this.editingDiscipline = { ...item };
      } else {
        this.editingDiscipline = this.getDefaultDiscipline();
      }
      this.disciplineDialog = true;
    },

    async saveDiscipline() {
      if (!this.editingDiscipline.id_card || !this.editingDiscipline.discipline_type) {
        this.showSnackbar("กรุณากรอกข้อมูลให้ครบ", "warning", "mdi-alert");
        return;
      }
      this.saving = true;
      try {
        const action = this.editingDiscipline.id ? "update" : "insert";
        const payload = {
          ApiKey: this.ApiKey,
          action: action,
          ...this.editingDiscipline,
          discipline_year: this.selectedYear,
          college_code: this.user.user_code
        };
        let result = await this.$http.post("gov_em_discipline.php", payload);
        if (result.data.status) {
          this.showSnackbar("บันทึกข้อมูลเรียบร้อย", "success", "mdi-check");
          this.disciplineDialog = false;
          await this.loadDisciplineData();
        } else {
          this.showSnackbar(result.data.message || "เกิดข้อผิดพลาด", "error", "mdi-alert");
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาดในการบันทึก", "error", "mdi-alert");
      } finally {
        this.saving = false;
      }
    },

    async deleteDiscipline(item) {
      if (confirm(`ต้องการลบข้อมูลวินัยของ ${item.full_name} หรือไม่?`)) {
        try {
          let result = await this.$http.post("gov_em_discipline.php", {
            ApiKey: this.ApiKey,
            action: "delete",
            id: item.id
          });
          if (result.data.status) {
            this.showSnackbar("ลบข้อมูลเรียบร้อย", "success", "mdi-check");
            await this.loadDisciplineData();
          }
        } catch (error) {
          this.showSnackbar("เกิดข้อผิดพลาดในการลบ", "error", "mdi-alert");
        }
      }
    },

    // === รายงาน ===
    async generateReport() {
      this.loading = true;
      try {
        let result = await this.$http.post("gov_em_assessment_report.php", {
          ApiKey: this.ApiKey,
          action: "generate_report",
          college_code: this.user.user_code,
          report_year: this.selectedYear
        });
        if (result.data.status) {
          this.reportSummary = result.data.summary;
          this.showSnackbar("สร้างรายงานสรุปเรียบร้อย", "success", "mdi-check");
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาดในการสร้างรายงาน", "error", "mdi-alert");
      } finally {
        this.loading = false;
      }
    },

    // === ส่งออก Excel ตามแบบ ปผ.พนร. ===
    exportToExcel() {
      const wb = XLSX.utils.book_new();
      const yearShort = String(this.selectedYear).slice(-2);
      const collegeName = this.collegeData.user_firstname || "";

      const personnelMap = {};

      this.assessmentData.forEach(item => {
        const key = item.id_card;
        if (!personnelMap[key]) {
          personnelMap[key] = {
            full_name: item.full_name,
            id_position: item.id_position || "",
            name_postion: item.name_postion || "",
            date_app_now: item.date_app_now || "",
            salary_s: item.salary_s || "",
            round1: null, round2: null,
            attendance: null, discipline: "-"
          };
        }
        if (item.assessment_round == 1) personnelMap[key].round1 = item;
        else if (item.assessment_round == 2) personnelMap[key].round2 = item;
      });

      this.attendanceData.forEach(item => {
        const key = item.id_card;
        if (!personnelMap[key]) {
          personnelMap[key] = {
            full_name: item.full_name, id_position: "", name_postion: "",
            date_app_now: "", salary_s: "",
            round1: null, round2: null, attendance: null, discipline: "-"
          };
        }
        personnelMap[key].attendance = item;
      });

      this.disciplineData.forEach(item => {
        const key = item.id_card;
        if (personnelMap[key]) {
          personnelMap[key].discipline = item.discipline_type + (item.court_case ? " (มีคดีอาญา)" : "");
        }
      });

      const headers = [
        ["แบบรายงานผลการประเมินการปฏิบัติงาน และรายงานข้อมูลการลา/มาสาย/ขาดราชการ ของพนักงานราชการ"],
        ["ประจำปีงบประมาณ พ.ศ. " + this.selectedYear],
        ["ชื่อหน่วยงาน: " + collegeName],
        ["เกณฑ์คะแนน: ดีเด่น 95-100 | ดีมาก 85-94 | ดี 75-84 | พอใช้ 65-74 | ต้องปรับปรุง <65 (ตามประกาศ สอศ. พ.ศ. 2569)"],
        [],
        [
          "ลำดับ", "ชื่อ-สกุล\nพนักงานราชการ", "เลขที่\nตำแหน่ง",
          "วันเริ่มปฏิบัติงาน", "ค่าตอบแทน", "รอบ\nการประเมิน",
          "ผลสัมฤทธิ์\n(เต็ม 80)", "สมรรถนะ/พฤติกรรม\n(เต็ม 20)",
          "คะแนนรวม\n2 ด้าน", "สรุประดับผล",
          "ลาป่วย\n(ครั้ง)", "ลาป่วย\n(วัน)", "ลาป่วย\n(วันทำการ)",
          "ลาคลอดบุตร\n(ครั้ง)", "ลาคลอดบุตร\n(วัน)", "ลาคลอดบุตร\n(วันทำการ)",
          "ลากิจส่วนตัว\n(ครั้ง)", "ลากิจส่วนตัว\n(วัน)", "ลากิจส่วนตัว\n(วันทำการ)",
          "ลาราชการทหาร\n(ครั้ง)", "ลาราชการทหาร\n(วัน)", "ลาราชการทหาร\n(วันทำการ)",
          "จำนวน\nมาสาย", "จำนวน\nขาดราชการ", "การถูกลงโทษ\nทางวินัย/คดีอาญา"
        ]
      ];

      const rows = [];
      let seq = 1;
      Object.values(personnelMap).forEach(p => {
        const att = p.attendance || {};
        rows.push([
          seq, p.full_name, p.id_position, p.date_app_now, p.salary_s,
          "ครั้งที่ 1/" + yearShort,
          p.round1 ? p.round1.performance_score : "-",
          p.round1 ? p.round1.competency_score : "-",
          p.round1 ? p.round1.total_score : "-",
          p.round1 ? p.round1.performance_grade : "-",
          att.sick_leave_times || "-", att.sick_leave_days || "-", att.sick_leave_workdays || "-",
          att.maternity_leave_times || "-", att.maternity_leave_days || "-", att.maternity_leave_workdays || "-",
          att.personal_leave_times || "-", att.personal_leave_days || "-", att.personal_leave_workdays || "-",
          att.military_leave_times || "-", att.military_leave_days || "-", att.military_leave_workdays || "-",
          att.late_count || "-", att.absent_count || "-", p.discipline
        ]);
        rows.push([
          "", "", "", "", "",
          "ครั้งที่ 2/" + yearShort,
          p.round2 ? p.round2.performance_score : "-",
          p.round2 ? p.round2.competency_score : "-",
          p.round2 ? p.round2.total_score : "-",
          p.round2 ? p.round2.performance_grade : "-",
          "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""
        ]);
        seq++;
      });

      const sheetData = [...headers, ...rows];
      const ws = XLSX.utils.aoa_to_sheet(sheetData);

      ws["!cols"] = [
        { wch: 6 }, { wch: 25 }, { wch: 10 }, { wch: 16 }, { wch: 12 },
        { wch: 14 }, { wch: 10 }, { wch: 12 }, { wch: 10 }, { wch: 12 },
        { wch: 8 }, { wch: 8 }, { wch: 8 }, { wch: 8 }, { wch: 8 }, { wch: 8 },
        { wch: 8 }, { wch: 8 }, { wch: 8 }, { wch: 8 }, { wch: 8 }, { wch: 8 },
        { wch: 8 }, { wch: 10 }, { wch: 20 }
      ];

      ws["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 24 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: 24 } },
        { s: { r: 2, c: 0 }, e: { r: 2, c: 24 } },
        { s: { r: 3, c: 0 }, e: { r: 3, c: 24 } }
      ];

      XLSX.utils.book_append_sheet(wb, ws, "แบบ ปผ.พนร.");

      const fileName = `ปผ_พนร_${this.selectedYear}_${collegeName || "report"}.xlsx`;
      XLSX.writeFile(wb, fileName);
      this.showSnackbar("ส่งออก Excel เรียบร้อย", "success", "mdi-download");
    },

    // === Helper Functions ===
    // *** ช่วงสีตามประกาศ สอศ. ***
    getScoreColor(score) {
      if (score >= 95) return "green";
      if (score >= 85) return "blue";
      if (score >= 75) return "teal";
      if (score >= 65) return "orange";
      return "red";
    },

    getGradeColor(grade) {
      const colors = {
        "ดีเด่น": "green",
        "ดีมาก": "blue",
        "ดี": "teal",
        "พอใช้": "orange",
        "ต้องปรับปรุง": "red",
        "ควรปรับปรุง": "red" // backward compatibility
      };
      return colors[grade] || "grey";
    },

    getStatusColor(status) {
      const colors = {
        "draft": "grey",
        "submitted": "blue",
        "approved": "green",
        "rejected": "red"
      };
      return colors[status] || "grey";
    },

    getStatusLabel(status) {
      const labels = {
        "draft": "ร่าง",
        "submitted": "ส่งแล้ว",
        "approved": "อนุมัติ",
        "rejected": "ส่งกลับ"
      };
      return labels[status] || status || "ร่าง";
    },

    getDisciplineTypeColor(type) {
      const colors = {
        "ตักเตือน": "yellow darken-2",
        "ภาคทัณฑ์": "orange",
        "ตัดเงินเดือน": "deep-orange",
        "ลดเงินเดือน": "red",
        "ปลดออก": "red darken-2",
        "ไล่ออก": "red darken-4"
      };
      return colors[type] || "grey";
    },

    getLogActionColor(action) {
      const colors = {
        "insert": "green",
        "update": "blue",
        "delete": "red",
        "status_change": "primary",
        "file_upload": "teal",
        "file_delete": "orange"
      };
      return colors[action] || "grey";
    },

    getLogActionLabel(action) {
      const labels = {
        "insert": "เพิ่มใหม่",
        "update": "แก้ไข",
        "delete": "ลบ",
        "status_change": "เปลี่ยนสถานะ",
        "file_upload": "อัปโหลดไฟล์",
        "file_delete": "ลบไฟล์"
      };
      return labels[action] || action;
    },

    getFileCategoryColor(cat) {
      const colors = {
        "pf_pnr_1_1": "blue",
        "pf_pnr_1_2": "teal",
        "pf_pnr_1_3": "primary",
        "pf_pnr_1_4": "primary",
        "supporting_doc": "orange",
        "other": "grey"
      };
      return colors[cat] || "grey";
    },

    getFileCategoryLabel(cat) {
      const labels = {
        "pf_pnr_1_1": "ปผ.พนร. 1-1",
        "pf_pnr_1_2": "ปผ.พนร. 1-2",
        "pf_pnr_1_3": "ปผ.พนร. 1-3",
        "pf_pnr_1_4": "ปผ.พนร. 1-4",
        "supporting_doc": "เอกสารประกอบ",
        "other": "อื่นๆ"
      };
      return labels[cat] || cat;
    },

    formatNumber(value) {
      if (isNaN(value) || value === null || value === undefined) return "0.00";
      return Number(value).toFixed(2);
    },

    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("th-TH");
    },

    formatDateTime(dt) {
      if (!dt) return "";
      return new Date(dt).toLocaleString("th-TH", {
        year: "numeric", month: "short", day: "numeric",
        hour: "2-digit", minute: "2-digit"
      });
    },

    formatFileSize(bytes) {
      if (!bytes) return "0 B";
      const k = 1024;
      const sizes = ["B", "KB", "MB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + " " + sizes[i];
    },

    showSnackbar(text, color = "success", icon = "mdi-check") {
      this.snackbar = { show: true, text, color, icon };
    }
  }
};
</script>

<style scoped>
.v-data-table >>> .v-data-table__wrapper {
  overflow-x: auto;
  max-height: 600px;
  overflow-y: auto;
}

.v-card-text h3 {
  font-size: 1.5rem;
  font-weight: bold;
}

.v-card-text p {
  margin-bottom: 0;
  font-size: 0.875rem;
}

.v-tabs >>> .v-tab {
  text-transform: none;
  font-weight: 500;
}

.v-dialog >>> .v-card__title.grey {
  border-bottom: 1px solid #e0e0e0;
}
</style>